import {RSAA} from "redux-api-middleware";

export const ADMIN_MENU_SET = 'ADMIN_MENU_SET';
export const ADMIN_MENU_LOADING = 'ADMIN_MENU_LOADING';


export const fetchInGameMenuAction = (gameId) => ({
    [RSAA]: {
        endpoint: `/api/v1/backend/menu/game/${gameId}`,
        method: 'GET',
        credentials: 'same-origin',
        types: [
            {
                type: ADMIN_MENU_LOADING,
                meta: {source: 'inGame'}
            },
            {
                type: ADMIN_MENU_SET,
                payload: (action, state, res) => (
                    res.json().then(
                        json => {
                            return (json.data);
                        }
                    )
                ),
                meta: {source: 'inGame'}
            },
            'FAILURE'
        ]
    }
});

export const fetchGeneralMenuAction = () => ({
    [RSAA]: {
        endpoint: `/api/v1/backend/menu`,
        method: 'GET',
        credentials: 'same-origin',
        types: [
            {
                type: ADMIN_MENU_LOADING,
                meta: {source: 'general'}
            },
            {
                type: ADMIN_MENU_SET,
                payload: (action, state, res) => (
                    res.json().then(
                        json => (json.data)
                    )
                ),
                meta: {source: 'general'}
            },
            'FAILURE'
        ]
    }
});